var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 9.5C0.5 4.5372 4.5372 0.5 9.5 0.5C14.4628 0.5 18.5 4.5372 18.5 9.5C18.5 14.4628 14.4628 18.5 9.5 18.5C4.5372 18.5 0.5 14.4628 0.5 9.5ZM13.6973 8.07201C14.0898 7.68353 14.0932 7.05038 13.7047 6.65781C13.3162 6.26525 12.6831 6.26193 12.2905 6.6504L8.69174 10.2116L7.20442 8.78508C6.80584 8.40278 6.17281 8.41598 5.79051 8.81456C5.40822 9.21314 5.42141 9.84617 5.81999 10.2285L8.01042 12.3294C8.40167 12.7047 9.02069 12.6999 9.40603 12.3185L13.6973 8.07201Z",
    fill: "#747085"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGrey);
export default __webpack_public_path__ + "static/media/check_grey.c069de6b7070164585ed351202fff452.svg";
export { ForwardRef as ReactComponent };